var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"title":_vm.title},on:{"click":_vm.selectFile}},[_vm._v(_vm._s(_vm.title))]),_c('form',[_c('input',{ref:"upload",staticClass:"upload-button",attrs:{"type":"file","accept":_vm.accept},on:{"change":_vm.uploadFile}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }